import * as formState from "./formState";

export  default  function (store, stateName) {
    if (!store.hasModule(stateName)) {
        store.registerModule(stateName, formState, {preserveState: false});
    }
}
